// extracted by mini-css-extract-plugin
module.exports = {"button":"FacebookAuth_button__1vmQL GoogleAuth_button__iiNbL","icon":"FacebookAuth_icon__pLXGG GoogleAuth_icon__2svQZ"};